/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  function defaultOption(opt, def) {
    return typeof opt === 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) {
      return '0';
    }
    const negativeString = number < 0 ? '-' : '';
    const n = Math.abs(number).toFixed(precision).split('.');
    const digits = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return negativeString + digits + (n[1] ? decimal + n[1] : '');
  }

  /**
   * @param {number} cents
   * @param {string} format
   * @returns {string}
   */
  function formatMoney(cents, format) {
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || '${{amount}}';
    const placeholder = formatString.match(placeholderRegex);
    if (!placeholder) {
      return formatString;
    }
    let value = cents / 100;
    switch (placeholder[1]) {
      case 'amount':
        value = formatWithDelimiters(value, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(value, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(value, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(value, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(value, 2, "'");
        break;
      default:
        value = formatWithDelimiters(value, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function unitPriceCentsFromForm(form) {
    const btn = form.querySelector('.product-form__add-button[data-unit-price-cents]');
    if (!btn) {
      return null;
    }
    const picker = form.querySelector('variant-picker script[data-variant]');
    if (picker) {
      try {
        const variant = JSON.parse(picker.textContent || '{}');
        if (typeof variant.price === 'number') {
          return variant.price;
        }
      } catch (e) {}
    }
    const fromAttr = parseInt(btn.getAttribute('data-unit-price-cents'), 10);
    return Number.isFinite(fromAttr) ? fromAttr : null;
  }

  function quantityFromForm(form) {
    const input = form.querySelector('[name="quantity"]');
    let qty = parseInt(input && input.value ? String(input.value) : '1', 10);
    if (!Number.isFinite(qty) || qty < 1) {
      qty = 1;
    }
    return qty;
  }

  function updateProductFormAddToCartLineTotal(form) {
    if (!form || !form.classList.contains('product-form')) {
      return;
    }
    const btn = form.querySelector('.product-form__add-button[data-unit-price-cents]');
    const totalEl = btn && btn.querySelector('[data-add-to-cart-line-total]');
    if (!btn || !totalEl || !window.theme) {
      return;
    }
    const unit = unitPriceCentsFromForm(form);
    if (unit == null) {
      return;
    }
    const fmt = window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;
    totalEl.textContent = formatMoney(unit * quantityFromForm(form), fmt);
  }

  function onQuantityEvent(event) {
    const form = event.target && event.target.closest && event.target.closest('form.product-form');
    if (form) {
      updateProductFormAddToCartLineTotal(form);
    }
  }

  function bindProductFormLineTotal(form) {
    if (!form || form.dataset.addToCartLineTotalBound) {
      return;
    }
    form.dataset.addToCartLineTotalBound = 'true';
    form.addEventListener('product:rerender', function () {
      updateProductFormAddToCartLineTotal(form);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('form.product-form').forEach(function (form) {
      bindProductFormLineTotal(form);
      updateProductFormAddToCartLineTotal(form);
    });
  });

  document.addEventListener('variant:change', function (event) {
    var form = event.target;
    if (form && form.matches && form.matches('form.product-form')) {
      bindProductFormLineTotal(form);
      window.requestAnimationFrame(function () {
        updateProductFormAddToCartLineTotal(form);
      });
    }
  });

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) {
            continue;
          }
          if (node.matches && node.matches('form.product-form')) {
            bindProductFormLineTotal(node);
            updateProductFormAddToCartLineTotal(node);
          }
          if (node.querySelectorAll) {
            node.querySelectorAll('form.product-form').forEach(function (form) {
              bindProductFormLineTotal(form);
              updateProductFormAddToCartLineTotal(form);
            });
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('change', function (event) {
    if (event.target.matches && event.target.matches('[name="quantity"]')) {
      onQuantityEvent(event);
    }
  });

  document.addEventListener('input', function (event) {
    if (event.target.matches && event.target.matches('[name="quantity"]')) {
      onQuantityEvent(event);
    }
  });
})();
